import React from 'react';
import { Dropdown } from 'primereact/dropdown';

function PrimeReactDropdown(props) {
  const { value = '', options = [], onChange = (e) => {}, name = '', isFilter = false, itemTemplate, disabled, ...rest } = props || {};
  return (
    <Dropdown
      value={value}
      name={name}
      options={options}
      onChange={(e) => {
        onChange(e);
      }}
      filter={isFilter}
      filterPlaceholder="Search"
      resetFilterOnHide={true} //clearing search keyword on hide
      itemTemplate={itemTemplate}
      disabled={disabled}
      {...rest}
    />
  );
}

export default PrimeReactDropdown;
